/* eslint-disable no-nested-ternary */
import { ArrowBack, Edit } from '@mui/icons-material';
import {
    Box,
    Button,
    Divider,
    IconButton,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import loading from '../../../assets/images/icons/loading.gif';
import DataNotAvailablePage from 'reusable-components/data-not-found';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import axios from 'axios';
import useMessageDispatcher from 'hooks/useMessageDispatcher';
import { dispatch } from 'store';
import AddPrevSerialization from './AddPrevSerialization';

const header = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
        'Content-Type': 'application/json'
    }
};

const List = ({ setOpen, values, setFieldValue, isLoading, fetchSessions, fetchCourseDetails }) => {
    const navigate = useNavigate();
    const [serializationData, setSerializationData] = useState(null);
    const [gradeSerializationData, setGradeSerializationData] = useState([]);
    const showMessage = useMessageDispatcher();
    const [openSerialization, setOpenSerialization] = useState(false);
    const [examEditData, setExamEditData] = useState(null);
    const [courseList, setCourseList] = useState([]);
    const [isEdit, setIsEdit] = useState(null);

    const handleEdit = async (row) => {
        setOpen(true);
        await fetchSessions();
        if (row?.sessionIds[0]) {
            await fetchCourseDetails(row?.sessionIds[0]);
            setFieldValue('sessionIds', row?.sessionIds);
        }
        const courses = row?.courseDetailIds?.map((c) => c);
        setFieldValue('type', 'EDIT');
        setFieldValue('id', row?.id);
        setFieldValue('courseDetailIds', courses);
        setFieldValue('examName', row?.examName);
        setFieldValue('startDate', row?.startDate);
        setFieldValue('endDate', row?.endDate);
        setFieldValue('semesterNo', row?.semester);
        setFieldValue('examMode', row?.paperMode);
    };

    const getGradeSerialization = async (data) => {
        try {
            const response = await axios.get(`/v1/exams/list/grade-serial?examGroupId=${data?.id}&sessionId=${data.sessionIds[0]}`, header);
            if (response.status === 200) {
                setGradeSerializationData(response.data.data);
            }
        } catch (error) {
            if (!error.response) {
                // dispatch(showMessage({ message: error.message, type: 'error' }));
            } else {
                // dispatch(showMessage({ message: error.response.data.Msg, type: 'error' }));
            }
        }
    };

    const getSerialization = async (id) => {
        try {
            const response = await axios.get(
                `/v1/exams/page/hall-ticket/serialization?examGroupId=${id}&pageNumber=0&pageSize=100`,
                header
            );
            if (response.status === 200) {
                setSerializationData(response.data.data?.content[0]);
            }
        } catch (error) {
            if (!error.response) {
                dispatch(showMessage({ message: error.message, type: 'error' }));
            } else {
                dispatch(showMessage({ message: error.response.data.Msg, type: 'error' }));
            }
        }
    };

    const getCourseList = () => {
        axios
            .get(`/v1/courses/list/by-filter`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                setCourseList(result.data.courseList);
            });
    };

    const initialval = {
        courseType: 'ALL',
        examGroupId: '',
        enrollmentStartsFrom: 0,
        numberLength: 0,
        year: 0,
        courseId: ''
    };

    const handleClickOpen = (row) => {
        getSerialization(row.id);
        getGradeSerialization(row);
        setExamEditData(row);
        setOpenSerialization(true);
    };

    const handleCloseSerialization = () => setOpenSerialization(false);

    const handleSubmitGradeSheet = async (values, { setSubmitting }) => {
        setSubmitting(true);
        // const payload = {
        //     id: examEditData?.id,
        //     sessionId: examEditData.sessionIds[0],
        //     courseId: values?.courseId,
        //     examGroupId: examEditData?.id,
        //     defaultGradeSerial: true,
        //     length: values.numberLength,
        //     startsFrom: values.enrollmentStartsFrom
        // };
        console.log(values, 'payload');

        try {
            const response = await axios.post('/v1/exams/add-update/grade-sheet-serial', values?.gradeSheets, header);
            if (response.status === 200) {
                showMessage({ message: response.data.Msg, type: 'success' });
                handleCloseSerialization();
                setIsEdit(null);
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, type: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, type: 'error' });
            }
        }
    };

    const handleSubmitHallTicket = async (values, { setSubmitting }) => {
        setSubmitting(true);
        const payload = {
            courseType: values.courseType,
            enrollmentStartsFrom: values.enrollmentStartsFrom,
            examGroupId: examEditData?.id,
            numberLength: values.numberLength,
            year: values.year
        };

        try {
            const response = await axios.post('/v1/exams/add-update/hall-ticket/serialization', payload, header);
            if (response.status === 200) {
                showMessage({ message: response.data.Msg, type: 'success' });
                handleCloseSerialization();
                setIsEdit(null);
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, type: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, type: 'error' });
            }
        }
    };

    useEffect(() => {
        getCourseList();
    }, []);

    return (
        <MainCard sx={{ minHeight: '80vh' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" alignItems="center">
                    <Tooltip title="Go Back">
                        <IconButton onClick={() => navigate(-1)}>
                            <ArrowBack sx={{ color: '#212429' }} />
                        </IconButton>
                    </Tooltip>
                    <Typography variant="h4">Exam List</Typography>
                </Box>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    Create Exam
                </Button>
            </Box>
            <Divider sx={{ mt: 2, mb: 1 }} />
            {isLoading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <img height="200px" src={loading} alt="Loading" />
                </Box>
            ) : values?.examList?.length === 0 ? (
                <DataNotAvailablePage style={{ height: '60vh' }} />
            ) : (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ borderBottom: '2px solid #D0D0D0' }}>
                                <TableCell style={{ fontWeight: 500 }}>Sl.No.</TableCell>
                                <TableCell style={{ fontWeight: 500 }}>Exam Name</TableCell>
                                <TableCell style={{ fontWeight: 500 }}>Exam Ongoing</TableCell>
                                <TableCell style={{ fontWeight: 500 }}>Start Date</TableCell>
                                <TableCell style={{ fontWeight: 500 }}>End Date</TableCell>
                                <TableCell style={{ fontWeight: 500 }}>Exam Type</TableCell>
                                <TableCell style={{ fontWeight: 500 }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        {values?.examList.map((s, i) => (
                            <TableRow sx={{ borderBottom: '2px solid #D0D0D0' }}>
                                <TableCell>{i + 1}</TableCell>
                                <TableCell>{s?.examName}</TableCell>
                                <TableCell>{s?.active ? 'Yes' : 'No'}</TableCell>
                                <TableCell>{s?.startDate ? moment(s.startDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '-'}</TableCell>
                                <TableCell>{s?.endDate ? moment(s.endDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '-'}</TableCell>

                                <TableCell>{s?.semesterExam === false ? 'Sessional Exam' : 'Semester Exam'}</TableCell>
                                <TableCell>
                                    <Tooltip title="Edit Exam">
                                        <IconButton color="secondary" onClick={() => handleEdit(s)}>
                                            <Edit />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Exam Serializations">
                                        <IconButton sx={{ color: 'black' }} onClick={() => handleClickOpen(s)}>
                                            <FormatListNumberedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </Table>
                </TableContainer>
            )}

            {openSerialization && (
                <AddPrevSerialization
                    open={openSerialization}
                    handleClose={handleCloseSerialization}
                    initialValues={initialval}
                    serializationData={serializationData}
                    gradeSerializationData={gradeSerializationData}
                    handleSubmit={handleSubmitHallTicket}
                    courseList={courseList}
                    handleSubmitGradeSheet={handleSubmitGradeSheet}
                    examEditData={examEditData}
                />
            )}
        </MainCard>
    );
};

export default List;
